/**
 * 音频配置选项接口
 */
export interface AudioConfigOptions {
  /** 录音采样率（默认：16000） */
  sampleRate?: number;
  /** 录音声道数（默认：1） */
  numChannels?: number;
  /** 播放采样率（默认：16000） */
  playerSampleRate?: number;
  /** 每帧音频长度（毫秒，默认：600） */
  frameMs?: number;
  /** 静音阈值（默认：1，越大越“难”触发静音） */
  silenceThreshold?: number;
  /** 静音持续时间（毫秒，默认：1000） */
  silenceDuration?: number;
  /** 回声消除（AEC）：用于降低程序播放声被麦克风录入（默认：开启） */
  echoCancellation?: boolean;
  /** 噪声抑制：用于降低环境噪声（默认：开启） */
  noiseSuppression?: boolean;
  /** 自动增益控制（AGC）：用于自动调节输入音量（默认：关闭） */
  autoGainControl?: boolean;
}

/**
 * 音频配置类
 */
export class AudioConfig {
  // 默认配置常量
  static readonly DEFAULT_SAMPLE_RATE = 16000;
  static readonly DEFAULT_NUM_CHANNELS = 1;
  static readonly DEFAULT_PLAYER_SAMPLE_RATE = 16000;
  static readonly DEFAULT_FRAME_MS = 600;
  static readonly DEFAULT_SILENCE_THRESHOLD = 1; // 默认静音阈值
  static readonly DEFAULT_SILENCE_DURATION = 1000; // 默认静音时长阈值(ms) 超过该时长时，发送剩余帧
  static readonly DEFAULT_ECHO_CANCELLATION = true; // 回声消除默认开启
  static readonly DEFAULT_NOISE_SUPPRESSION = true; // 噪声抑制默认开启
  static readonly DEFAULT_AUTO_GAIN_CONTROL = false; // 自动增益控制默认关闭

  // 实例属性
  public readonly sampleRate: number;
  public readonly numChannels: number;
  public readonly playerSampleRate: number;
  public readonly frameMs: number;
  public readonly silenceThreshold: number;
  public readonly silenceDuration: number;
  /** 回声消除（AEC）：用于降低程序播放声被麦克风录入 */
  public readonly echoCancellation: boolean;
  /** 噪声抑制：用于降低环境噪声 */
  public readonly noiseSuppression: boolean;
  /** 自动增益控制（AGC）：用于自动调节输入音量 */
  public readonly autoGainControl: boolean;

  constructor(options: AudioConfigOptions = {}) {
    this.sampleRate = options.sampleRate ?? AudioConfig.DEFAULT_SAMPLE_RATE;
    this.numChannels = options.numChannels ?? AudioConfig.DEFAULT_NUM_CHANNELS;
    this.playerSampleRate = options.playerSampleRate ?? AudioConfig.DEFAULT_PLAYER_SAMPLE_RATE;
    this.frameMs = options.frameMs ?? AudioConfig.DEFAULT_FRAME_MS;
    this.silenceThreshold = options.silenceThreshold ?? AudioConfig.DEFAULT_SILENCE_THRESHOLD;
    this.silenceDuration = options.silenceDuration ?? AudioConfig.DEFAULT_SILENCE_DURATION;
    this.echoCancellation = options.echoCancellation ?? AudioConfig.DEFAULT_ECHO_CANCELLATION;
    this.noiseSuppression = options.noiseSuppression ?? AudioConfig.DEFAULT_NOISE_SUPPRESSION;
    this.autoGainControl = options.autoGainControl ?? AudioConfig.DEFAULT_AUTO_GAIN_CONTROL;
  }
}
